import { type DashboardKey } from '@core/analytics-api/analytics-api.types';

/** Реестр дашбордов: добавление — строка здесь плюс маршрут в `app.routes.ts`. */

export interface DashboardEntry {
  /** Путь маршрута без ведущего слеша. */
  readonly path: string;
  readonly label: string;
  /** Название в шапке, если оно длиннее подписи карточки на главной. */
  readonly title?: string;
  readonly caption: string;
  readonly icon: string;
  /** Логотип компании — показывается в шапке вместо логотипа сервиса. Пусто — значок и название. */
  readonly logo: string;
  /** Фирменная шапка и оформление компании. */
  readonly brand: 'vasta-hotel-management' | 'ruslet';
  /** Дашборд ещё не сделан — карточка показывается, но не кликается. */
  readonly ready: boolean;
  /** Есть живой источник, кроме заглушки: показывать переключатель «Демо / Сервер». */
  readonly serverSource: boolean;
  /** Ключ в `GET /dashboards` Vasta.Analytics.Api: дашборд виден, только если он там есть. Нет ключа — скрыт при входе. */
  readonly apiKey?: DashboardKey;
}

export const DASHBOARDS: readonly DashboardEntry[] = [
  {
    path: 'dashboards/manager-flash',
    apiKey: 'hotels',
    label: 'Manager Flash',
    caption: 'Доход, загрузка и выполнение плана',
    icon: '@tui.zap',
    logo: '/icons/vasta-logo.svg',
    brand: 'vasta-hotel-management',
    ready: true,
    serverSource: true,
  },
  {
    path: 'dashboards/restaurant-flash',
    apiKey: 'restaurants',
    label: 'Restaurant Flash',
    caption: 'Рестораны и бары при отелях',
    icon: '@tui.utensils-crossed',
    logo: '/icons/vasta-logo.svg',
    brand: 'vasta-hotel-management',
    ready: true,
    serverSource: true,
  },
  {
    path: 'dashboards/aquapark-flash',
    label: 'Aquapark Flash',
    caption: 'Аквапарк: билеты, гости и допуслуги',
    icon: '@tui.waves',
    logo: '/icons/vasta-logo.svg',
    brand: 'vasta-hotel-management',
    ready: true,
    serverSource: true,
    apiKey: 'aquapark',
  },
  {
    path: 'dashboards/quality',
    label: 'Дашборд качества',
    caption: 'Входной и межоперационный контроль',
    icon: '@tui.clipboard-check',
    logo: '',
    brand: 'ruslet',
    ready: true,
    serverSource: true,
    apiKey: 'quality',
  },
  {
    path: 'dashboards/payments',
    label: 'Расходование ДС',
    title: 'Мониторинг заявок на расходование денежных средств',
    caption: 'Заявки, лимиты, исполнение',
    icon: '@tui.wallet',
    logo: '',
    brand: 'ruslet',
    ready: true,
    serverSource: true,
    apiKey: 'payments',
  },
  {
    path: 'dashboards/production',
    label: 'План и производство',
    caption: 'Этапы, загрузка цехов, заказы',
    icon: '@tui.factory',
    logo: '',
    brand: 'ruslet',
    ready: true,
    serverSource: true,
    apiKey: 'production',
  },
  {
    path: 'dashboards/finance',
    label: 'Финансовая сводка',
    title: 'Финансово-управленческая сводка',
    caption: 'Остатки, задолженность, запасы',
    icon: '@tui.landmark',
    logo: '',
    brand: 'ruslet',
    ready: true,
    serverSource: false,
    apiKey: 'finance',
  },
];

/** Подпись компании над её дашбордами на главной. */
export const BRAND_LABELS: Readonly<Record<DashboardEntry['brand'], string>> = {
  'vasta-hotel-management': 'ВАСТА Отель Менеджмент',
  ruslet: 'РУСЛЕТ',
};

/** Дашборд, которому принадлежит адрес. */
export function findDashboard(url: string): DashboardEntry | undefined {
  const path = url.split('?')[0]?.replace(/^\//, '') ?? '';

  return DASHBOARDS.find((entry) => path.startsWith(entry.path));
}
